var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 211.47 294.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.01,
    y: 112.73,
    width: 189.54,
    height: 172.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.91,107.37H60.25V73.79S73,30.15,103.9,30.15s47.4,43.07,47.4,43.07v35.43h26.91V73.22S173.06,5.65,107.78,5.65,33.91,74.94,33.91,74.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.74,164.1a21.31,21.31,0,0,0-10.69,39.79v24.35a10.69,10.69,0,1,0,21.37,0V203.89a21.31,21.31,0,0,0-10.68-39.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.74,102.54h-5.1V77.9a77.91,77.91,0,1,0-155.81,0v24.63h-5.1A22.76,22.76,0,0,0,0,125.27V271.35a22.75,22.75,0,0,0,22.73,22.73h166a22.75,22.75,0,0,0,22.73-22.73V125.27A22.76,22.76,0,0,0,188.74,102.54ZM40.81,77.91a64.92,64.92,0,1,1,129.84,0v24.64h-13V77.9a51.94,51.94,0,1,0-103.87,0v24.63h-13Zm26,24.63V77.91a39,39,0,1,1,77.91,0v24.64ZM196.32,271.35a7.59,7.59,0,0,1-7.58,7.58h-166a7.59,7.59,0,0,1-7.58-7.58V125.27a7.59,7.59,0,0,1,7.58-7.58h166a7.59,7.59,0,0,1,7.58,7.58Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock-filled.81469446e4bb43f13fe345c9a6a9e120.svg";
export { ForwardRef as ReactComponent };